module.exports = {
    // 某一订单数据更新
    UpdateOrderDataEvent : "UpdateOrderDataEvent"
    
    // 远航数据更新（所有订单、刷次次数）
    ,UpdateVoyageDataEvent : "UpdateVoyageDataEvent"
    
    // 删除订单
    ,DeleteOrderDataEvent : "DeleteOrderDataEvent"
    
    // 红点更新
    ,UpdateVoyageRedEvent : "UpdateVoyageRedEvent"
    
    // 远航活动状态
    ,UpdateActivityStatusEvent : "UpdateActivityStatusEvent"
};